import { render, staticRenderFns } from "./roulette.vue?vue&type=template&id=3abc4e62&scoped=true&"
import script from "./roulette.vue?vue&type=script&lang=js&"
export * from "./roulette.vue?vue&type=script&lang=js&"
import style0 from "./roulette.vue?vue&type=style&index=0&id=3abc4e62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc4e62",
  null
  
)

export default component.exports